<template>
  <vx-card id="invoice-container" v-if="requestDetails">
    <invoice-data-view :invoice="invoice" :request="request" :request-details="requestDetails" />
    <div slot="footer">
      <template v-if="invoice.state === 'pending'">
        <vs-row vs-justify="flex-end" class="print-hidden">
          <vs-button
            icon-pack="feather"
            icon="icon-edit"
            color="primary"
            class="mr-2"
            v-if="requestDetails.reserve && request.status === 'accepted'"
            @click="openEditReservation()"
          >
            {{ $t('reservation.edit') }}
          </vs-button>
          <vs-button icon-pack="feather" icon="icon-edit" color="primary" class="mr-2" @click="editInvoice()">
            {{ $t('forms.edit') }}
          </vs-button>
          <vs-button icon-pack="feather" icon="icon-check" color="success" @click="activeDonePopup = true">
            {{ $t('invoices.done') }}
          </vs-button>
        </vs-row>
      </template>
      <template v-else-if="invoice.state === 'unpaid'">
        <vs-row vs-justify="flex-end" class="print-hidden">
          <vs-button
            color="warning"
            type="border"
            id="button-cash-loading"
            class="vs-con-loading__container mx-2"
            :disabled="payBtnDisable"
            @click="openCashConfirm"
          >
            {{ $t('invoices.cash') }}
          </vs-button>
        </vs-row>
      </template>
      <template v-else-if="invoice.state === 'cash_unpaid'">
        <vs-row vs-justify="flex-end" class="print-hidden">
          <vs-button
            color="success"
            id="button-pay-loading"
            class="vs-con-loading__container mx-2"
            :disabled="payBtnDisable"
            @click="payInvoice"
          >
            {{ $t('invoices.pay') }}
          </vs-button>
        </vs-row>
      </template>
    </div>

    <vs-popup
      :active="activeReserveEditPopup"
      @close="activeReserveEditPopup = false"
      :title="$t('reservation.edit')"
      v-if="requestDetails.reserve"
    >
      <date-picker
        type="datetime"
        v-model="reserveStartTime"
        :min="$moment().format()"
        :jump-minute="5"
        element="start-time"
      />
      <vs-input
        name="start-time"
        :value="
          $moment(reserveStartTime)
            .locale($vs.rtl ? 'fa' : 'en')
            .format('HH:mm dddd, DD MMMM YYYY')
        "
        id="start-time"
        v-validate="'required'"
        :label="$t('services.start_time')"
        :data-vv-as="$t('services.start_time')"
        class="w-full rf-input"
      />
      <date-picker
        type="datetime"
        v-model="reserveEndTime"
        :min="$moment(reserveStartTime).format()"
        :max="
          $moment(reserveStartTime)
            .add(1, 'day')
            .format()
        "
        :jump-minute="5"
        element="end-time"
      />
      <vs-input
        name="end-time"
        :value="
          $moment(reserveEndTime)
            .locale($vs.rtl ? 'fa' : 'en')
            .format('HH:mm dddd, DD MMMM YYYY')
        "
        id="end-time"
        v-validate="'required'"
        :label="$t('services.end_time')"
        :data-vv-as="$t('services.end_time')"
        class="w-full rf-input"
      />
      <vs-row vs-justify="flex-end">
        <vs-button
          icon-pack="feather"
          icon="icon-check"
          color="success"
          class="mt-3"
          @click="editReservation"
        >
          {{ $t('button.edit') }}
        </vs-button>
      </vs-row>
    </vs-popup>

    <vs-popup :active="activeDonePopup" @close="activeDonePopup = false" :title="$t('invoices.done_title')">
      <vs-textarea
        v-model="commendation"
        name="commendation"
        id="commendation"
        :label="$t('invoice.commendation')"
        class="w-full"
      />
      <vs-row vs-justify="flex-end">
        <vs-button icon-pack="feather" icon="icon-check" color="success" class="mt-3" @click="doneInvoice()">
          {{ $t('invoices.done') }}
        </vs-button>
      </vs-row>
    </vs-popup>
  </vx-card>
</template>

<script>
import InvoiceDataView from '@/views/pages/invoice/InvoiceDataView'
import modulePayping from '@/store/payping/modulePayping'
import moduleReserve from '@/store/reserve/moduleReserve.js'

export default {
  name: 'EmployeeInvoiceView',
  components: { InvoiceDataView },
  data() {
    return {
      invoice: {},
      request: {},
      requestDetails: null,
      payBtnDisable: false,
      activeReserveEditPopup: false,
      activeDonePopup: false,
      commendation: '',
      reserveStartTime: this.$moment().format(),
      reserveEndTime: this.$moment().format()
    }
  },
  methods: {
    editInvoice() {
      this.$router.push({ name: 'employee-invoice-edit', params: { id: this.invoice.id } })
    },
    openEditReservation() {
      this.reserveStartTime = this.requestDetails.reserve.startDate
      this.reserveEndTime = this.requestDetails.reserve.endDate
      this.activeReserveEditPopup = true
    },
    editReservation() {
      this.activeReserveEditPopup = false
      this.$store
        .dispatch('reserve/editReserve', {
          id: this.requestDetails.reserve.id,
          data: {
            startDate: this.reserveStartTime,
            endDate: this.reserveEndTime
          }
        })
        .then(() => {
          this.requestDetails.reserve.startDate = this.reserveStartTime
          this.requestDetails.reserve.endDate = this.reserveEndTime

          this.$vs.notify({
            title: this.$t('forms.successfully_edited'),
            text: '',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })
        })
    },
    doneInvoice() {
      this.$store
        .dispatch('request/updateRequestBySubject', {
          category: this.request.category,
          subject: this.request.subject,
          id: this.invoice.request.id,
          activity: 'InvoiceEditionConfirmation',
          data: { InvoiceEditionConfirmation: '', Commendation: this.commendation }
        })
        .then(() => {
          this.activeDonePopup = false
          this.$vs.notify({
            title: this.$t('invoices.done_successfully'),
            text: '',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })
          this.$router.push({ name: 'employee-invoice-list' })
        })
        .catch(() => {
          this.activeDonePopup = false
        })
    },
    payInvoice() {
      this.payBtnDisable = true

      this.$vs.loading({
        background: 'success',
        container: '#button-pay-loading',
        color: '#fff',
        scale: 0.45
      })

      this.$store
        .dispatch('payping/fetchPaymentIpg', this.invoice.paypingPaymentId)
        .then(response => {
          window.location = response.data
        })
        .finally(() => {
          this.activeSurveyPrompt = false
          this.payBtnDisable = false
          this.$vs.loading.close('#button-pay-loading > .con-vs-loading')
        })
    },
    openCashConfirm() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: this.$t('invoices.cash'),
        text: this.$t('invoices.cash_warn'),
        accept: () => {
          this.cashInvoice()
        },
        acceptText: this.$t('button.confirm'),
        cancelText: this.$t('button.cancel')
      })
    },
    cashInvoice() {
      this.$store.dispatch('invoice/cashInvoice', this.invoice.id).then(() => {
        this.$store.dispatch('invoice/fetchUnpaidInvoices', {
          skip: 0,
          limit: 100
        })
        this.invoice.state = 'cash_unpaid'
        this.$notifySuccess(this.$t('invoices.cashed_successfully'))
      })
    }
  },
  created() {
    this.$vs.loading()
    if (!modulePayping.isRegistered) {
      this.$store.registerModule('payping', modulePayping)
      modulePayping.isRegistered = true
    }
    if (!moduleReserve.isRegistered) {
      this.$store.registerModule('reserve', moduleReserve)
      moduleReserve.isRegistered = true
    }
    this.$store
      .dispatch('invoice/fetchInvoice', this.$route.params.id)
      .then(res => {
        this.invoice = JSON.parse(JSON.stringify(res.data))

        this.$store
          .dispatch('request/fetchHealthRequestById', this.invoice.request.id)
          .then(res => {
            this.request = JSON.parse(JSON.stringify(res.data))
            this.$store
              .dispatch('request/fetchRequestDetailsBySubject', {
                id: this.invoice.request.id,
                subject: this.request.subject,
                category: this.request.category
              })
              .then(res => {
                this.requestDetails = res.data
              })
          })
          .finally(() => this.$vs.loading.close())
      })
      .catch(() => this.$vs.loading.close())
  },
  mounted() {
    this.$emit('setAppClasses', 'invoice-page')
  }
}
</script>
